module.exports = __webpack_public_path__ + "img/frame-browser-foujita-long-es.34248f99.jpg";